module.exports = __webpack_public_path__ + "assets/img/38.435f36f9.png";